import React from "react";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import { FormattedMessage } from "react-intl";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import Tooltip from "@material-ui/core/Tooltip";
import get from "lodash/get";
import LeavePlan from "../Policy/LeavePlan/index";
import { ReducersTypes } from "../../../../../Constants";
import { instance } from "../../../../../Actions/AxiosInstance";
import { GetFeature } from "../../../../../Actions/commonAction";

export default class LeaveTypeWidget extends React.Component {
  state = {
    openDialog: false,
  };

  setOpenDialog = (val) => {
    if (val) {
      this.InitLeavesPolicy();
    } else {
      this.setState({ openDialog: val });
    }
  };

  InitLeavesPolicy = () => {
    const data = {
      isdraft: false,
      leavepolicyid: this.props.leaveoption.leavepolicyid,
      leaveid: this.props.leaveoption.leaveid || null,
      leavetypeid: [this.props.leaveoption.leavetypeid] || null,
    };
    instance
      .post("leaves/initleavepolicy", data)
      .then((result) => {
        console.log("result: ", result);
        if (result.data.result.initleavepolicy.length > 0) {
          const DATA = {
            InitLeavesPolicy: {
              // ...this.props.InitLeavesPolicy,
              isviewmode: true,
              details: [...result.data.result.leaveplandata.details],
              policy: [...result.data.result.leaveplandata.policy],
            },
          };
          this.props.CommonReducerAction(ReducersTypes.LEAVESPOLICY, {
            ...DATA.InitLeavesPolicy,
          });
        }
        setTimeout(() => {
          this.setState({ openDialog: true });
        }, 500);
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  };

  render() {
    const {
      leaveoption,
      toggleDrawer,
      leaveAction,
      applyLeave,
      showLeavePolicy,
      isFromModule,
    } = this.props;
    const { openDialog } = this.state;
    const LeaveObject = LeavePlan.find(
      (x) => x.leavetypeid == leaveoption.leavetypeid,
    );

    return (
      <Grid item xs={12} md={2} sm={4} className="padding8">
        <Dialog
          open={openDialog}
          onClose={() => this.setOpenDialog(false)}
          fullWidth={true}
          maxWidth="lg"
          aria-labelledby="max-width-dialog-title"
        >
          <DialogTitle id="max-width-dialog-title">Preview</DialogTitle>
          <DialogContent>
            {LeaveObject && (
              <LeaveObject.Component
                ChangeSteppername={() => {}}
                step={0}
                ParentIndex={0}
                leavetypeid={LeaveObject.leavetypeid}
                StepError={() => {}}
                click={() => {}}
                newPolicyCreate={false}
              />
            )}
          </DialogContent>
        </Dialog>
        <div className="margin-top-16">
          <Paper>
            <div>
              <div className="leave-type-section">
                <div>
                  {leaveoption.leavetypeid == 3 ? (
                    <div>
                      <div className="leave-days text-center">
                        <Tooltip title={leaveoption.isrestrictinprobation ? `You will be allowed to use this leave after you complete your probation period.` : leaveoption.isinsufficientexperience ? `To use this leave balance you need ${leaveoption.monthofexperience} months of work-experience.` : `${leaveoption.leavename}`} placement="top">
                          <div className="leave-type">
                            {leaveoption.leavename}
                          </div>
                        </Tooltip>
                        <div className="cursurpointer">
                          {leaveoption.isgiftallowed && !isFromModule ? (
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 24 24"
                              onClick={() =>
                                toggleDrawer(
                                  "right",
                                  true,
                                  "GiftTypeLeave",
                                  leaveoption,
                                )
                              }
                            >
                              <path
                                fill="rgba(0, 0, 0, 0.54)"
                                d="M20 6h-2.18c.11-.31.18-.65.18-1 0-1.66-1.34-3-3-3-1.05 0-1.96.54-2.5 1.35l-.5.67-.5-.68C10.96 2.54 10.05 2 9 2 7.34 2 6 3.34 6 5c0 .35.07.69.18 1H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-5-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM9 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm11 15H4v-2h16v2zm0-5H4V8h5.08L7 10.83 8.62 12 12 7.4l3.38 4.6L17 10.83 14.92 8H20v6z"
                              />
                            </svg>
                          ) : null}
                        </div>
                      </div>
                      <div className="text-center t-14">
                        {parseInt(
                          Math.floor(get(leaveoption, "leavecount", 1) / 60),
                        )}{" "}
                        Hrs &nbsp;
                        {leaveoption.leavecount < 0
                          ? -1 *
                            Math.floor((leaveoption.leavecount / 60).toFixed())
                          : Math.floor(
                              (leaveoption.leavecount % 60).toFixed(),
                            )}{" "}
                        Mins
                      </div>
                    </div>
                  ) : (
                    <div>
                      <div className="leave-days text-center">
                      <Tooltip title={leaveoption.isrestrictinprobation ? `You will be allowed to use this leave after you complete your probation period.` : leaveoption.isinsufficientexperience ? `To use this leave balance you need ${leaveoption.experienceinmonth} months of work-experience.`: `${leaveoption.leavename}`} placement="top">
                          <div className="leave-type">
                            {leaveoption.leavename}
                          </div>
                        </Tooltip>
                        <div className="cursurpointer">
                          {leaveoption.isgiftallowed && !isFromModule ? (
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 24 24"
                              onClick={() =>
                                toggleDrawer(
                                  "right",
                                  true,
                                  "GiftTypeLeave",
                                  leaveoption,
                                )
                              }
                            >
                              <path
                                fill="rgba(0, 0, 0, 0.54)"
                                d="M20 6h-2.18c.11-.31.18-.65.18-1 0-1.66-1.34-3-3-3-1.05 0-1.96.54-2.5 1.35l-.5.67-.5-.68C10.96 2.54 10.05 2 9 2 7.34 2 6 3.34 6 5c0 .35.07.69.18 1H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-5-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM9 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm11 15H4v-2h16v2zm0-5H4V8h5.08L7 10.83 8.62 12 12 7.4l3.38 4.6L17 10.83 14.92 8H20v6z"
                              />
                            </svg>
                          ) : null}
                        </div>
                      </div>
                      <div className="text-center t-14">
                        {leaveoption.displaycount &&
                          ` ${leaveoption.displaycount}`}
                      </div>
                    </div>
                  )}
                </div>
              </div>

              <div className="leave-action-section">
                <React.Fragment>
                  {leaveAction.map((option) => {
                    const getDisable = (name) => {
                      if (name == "Ledger") {
                        if (GetFeature("leaveLedger")) {
                          return true;
                        }
                        return false;
                      }
                      return true;
                    };
                    return (
                      <div key="-" className="padding-bottom-8 display-flex">
                        {getDisable(option.displayname) && (
                          <span>
                            <svg width="20" height="20" viewBox="0 0 24 24">
                              <path
                                fill="rgba(0, 0, 0, 0.54)"
                                d="M4 10.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0-6c-.83 0-1.5.67-1.5 1.5S3.17 7.5 4 7.5 5.5 6.83 5.5 6 4.83 4.5 4 4.5zm0 12c-.83 0-1.5.68-1.5 1.5s.68 1.5 1.5 1.5 1.5-.68 1.5-1.5-.67-1.5-1.5-1.5zM7 19h14v-2H7v2zm0-6h14v-2H7v2zm0-8v2h14V5H7z"
                              />
                            </svg>
                          </span>
                        )}
                        {/* <span className="leave-name">{option.displayname}</span> */}
                        {option.displayname == "Ledger" &&
                        GetFeature("leaveLedger") ? (
                          <span
                            className="leave-name"
                            onClick={() =>
                              toggleDrawer("right", true, "Ledger", leaveoption)
                            }
                          >
                            {option.displayname}
                          </span>
                        ) : (
                          " "
                        )}
                        {option.displayname == "View Logs" ? (
                          <span
                            className="leave-name"
                            onClick={() =>
                              toggleDrawer(
                                "right",
                                true,
                                "ViewLogs",
                                leaveoption,
                              )
                            }
                          >
                            {option.displayname}
                          </span>
                        ) : (
                          ""
                        )}
                        {/* {option.displayname == "View Policy" && !flag ? (
                          <span
                            className="leave-name"
                            onClick={() => this.setOpenDialog(true)}
                            // onClick={() => showLeavePolicy(leaveoption)}
                          >
                            {option.displayname}
                          </span>
                        ) : (
                          ""
                        )} */}
                      </div>
                    );
                  })}
                </React.Fragment>
              </div>
              {applyLeave && applyLeave.permissions.editable && (
                <div className="padding-left-12 padding-right-12 padding-bottom-8">
                  <Button
                    // className="width100 btn btn-primary-sm-blue"
                    style={{ height: "unset" }}
                    className={
                      leaveoption.active == 0
                        ? "width100 btn btn-primary-sm-grey"
                        : "width100 btn btn-primary-sm-blue"
                    }
                    variant="contained"
                    color="primary"
                    disabled={
                        !leaveoption.isrestrictinprobation
                        && !leaveoption.isinsufficientexperience
                          ? leaveoption.isdisable
                            ? true
                            : leaveoption.active == 0
                              ? true
                              : leaveoption.leavetypeid == 99 || leaveoption.leavetypeid == 100
                                ? leaveoption.displaycount == "0 Days"
                                  ? true
                              : false
                            : false
                         : true
                    }
                    onClick={() =>
                      toggleDrawer("right", true, "ApplyLeave", leaveoption)
                    }
                  >
                    <FormattedMessage
                      id="LbApplyleave"
                      defaultMessage="Apply Leave"
                    />
                  </Button>
                </div>
              )}
            </div>
          </Paper>
        </div>
      </Grid>
    );
  }
}
